import axios, { AxiosResponse } from "axios";
import { getApiBaseUrl } from "../baseUrl";

interface LoginPrefeituraRequest {
  email: string;
  senha: string;
}

interface LoginPrefeituraResponse {
  prefeituraId: number;
  nomePrefeitura: string;
  email: string;
  telefone?: string;
  whatsapp?: string;
  token: string;
}

export const loginPrefeitura = async (
  credentials: LoginPrefeituraRequest
): Promise<AxiosResponse<LoginPrefeituraResponse>> => {
  try {
    const apiUrl = `${getApiBaseUrl()}/prefeituras/login`;

    const response = await axios.post<LoginPrefeituraResponse>(
      apiUrl,
      credentials,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Se o response vier encapsulado em data.data
    if (response.data && typeof response.data === 'object' && 'data' in response.data) {
      const unwrappedData = (response.data as any).data;
      return {
        ...response,
        data: unwrappedData
      };
    }

    return response;
  } catch (error: any) {
    console.error("Erro ao fazer login da prefeitura:", error);
    throw error;
  }
};